var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 628,
    viewBox: "0 0 1200 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 0H0V628H1200V0Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.5 628C1104.5 608.8 1107.8 588.4 1107.8 567.2C1107.8 474.8 1045.9 396.8 961.2 372.5C967.2 358 970.5 342.1 970.5 325.4C970.5 257.2 915.2 201.9 847 201.9C835.3 201.9 823.9 203.5 813.2 206.6C767.5 133.1 686.1 84.2 593.2 84.2C473.1 84.2 372.1 166 342.9 276.9C203.7 281.2 92.2 395.4 92.2 535.6C92.2 568.2 98.2 599.3 109.2 628H1098.5Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.5 489.7C1005 478.6 977.8 452.9 943.8 447.7C870.5 436.5 812.2 523.6 738.1 520.7C698.6 519.2 665.4 492.3 634.1 468.2C602.8 444.1 565.9 420.3 526.8 426.3C494.8 431.2 466.2 455.9 434 452.2C397.8 448.1 376.2 411.5 352.8 383.5C320.9 345.5 275.8 319 227.4 308.1C146.9 352 92.2 437.4 92.2 535.6C92.2 568.2 98.2 599.3 109.2 628H1098.6C1104.6 608.8 1107.9 588.4 1107.9 567.2C1107.9 542.3 1103.4 518.4 1095.2 496.4C1075.5 497.4 1056.2 496.1 1037.5 489.7Z",
    fill: "#4792B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.3 526C898.8 517.9 839.9 533.7 781 538C709.9 543.3 638.6 531.8 569 516.6C503.3 502.3 438.4 484.7 374.5 463.8C295.1 437.9 215.7 406.6 133.6 395.1C107.4 435.5 92.2 483.7 92.2 535.5C92.2 568.1 98.2 599.2 109.2 627.9H1098.6C1104 610.7 1107.2 592.6 1107.8 573.8C1106.5 573.4 1105.1 573 1103.8 572.6C1054.6 557.7 1008.1 533.1 957.3 526Z",
    fill: "#FF9F9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3 599.9C354 596.2 332.6 599 316.2 588.2C297.3 575.8 289.4 547.7 267.3 543.1C245.8 538.5 226.9 559.7 205 560.9C187.6 561.8 172.2 550.1 160.6 537.1C149 524.2 139.1 509.1 124.4 499.8C116.1 494.5 105.4 491.8 95.7 492.9C93.4 506.8 92.2 521 92.2 535.6C92.2 568.2 98.2 599.3 109.2 628H419.6C407.7 613.9 391.5 603.4 373.3 599.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.7 573.8C1107.1 592.6 1103.9 610.8 1098.5 627.9H419.6C407.7 613.8 391.5 603.3 373.3 599.8C354 596.1 332.6 598.9 316.2 588.1C297.3 575.7 289.4 547.7 267.3 543C245.8 538.4 226.9 559.6 205 560.8C187.6 561.7 172.2 550 160.6 537C149 524 139.1 509 124.4 499.7C116.1 494.4 105.4 491.7 95.7 492.8C101.6 457.3 114.8 424.2 133.6 395.1C215.8 406.7 295.1 437.9 374.5 463.8C438.4 484.7 503.3 502.3 569 516.6C605.3 524.5 642 531.4 678.8 535.4C686.9 536.3 695 537 703.1 537.6C729 539.5 755 539.8 781 537.9C809.6 535.8 838.3 531 866.9 527.5C893.3 524.3 919.7 522.3 946 524.6C949.8 524.9 953.5 525.4 957.3 525.9C1008.1 533 1054.7 557.5 1103.7 572.5C1105 573.1 1106.4 573.5 1107.7 573.8Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.1 496.4C1075.5 497.4 1056.2 496.1 1037.6 489.7C1005.1 478.6 977.9 452.9 943.9 447.7C870.6 436.5 812.3 523.6 738.2 520.7C698.7 519.2 665.5 492.3 634.2 468.2C602.9 444.1 566 420.3 526.9 426.3C494.9 431.2 466.3 455.9 434.1 452.2C397.9 448.1 376.3 411.5 352.9 383.5C321 345.5 275.9 319 227.5 308.1C189.4 328.8 157.1 358.9 133.6 395.2C215.8 406.8 295.1 438 374.5 463.9C438.4 484.8 503.3 502.4 569 516.7C638.7 531.9 709.9 543.3 781 538.1C839.9 533.7 898.8 518 957.3 526.1C1008.1 533.1 1054.7 557.7 1103.7 572.7C1105 573.1 1106.4 573.5 1107.7 573.9C1107.8 571.7 1107.8 569.5 1107.8 567.2C1107.8 542.3 1103.3 518.4 1095.1 496.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4 73.5C79.4 73.5 49 97.7 39.6 130.7H191.3C181.9 97.6 151.5 73.5 115.4 73.5Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4 73.5C286.4 73.5 256 97.7 246.6 130.7H398.3C388.8 97.6 358.4 73.5 322.4 73.5Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.8 49C172.3 49 128.9 83.5 115.5 130.7H332.2C318.7 83.5 275.2 49 223.8 49Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.3 111C157.6 111 139.3 125.6 133.6 145.5H225C219.3 125.6 201 111 179.3 111Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 111C282.3 111 264 125.6 258.3 145.5H349.7C344 125.6 325.7 111 304 111Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.6 96.3C213.6 96.3 187.4 117.1 179.3 145.5H309.9C301.7 117.1 275.6 96.3 244.6 96.3Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.7 102.5C853.5 102.5 833 118.8 826.7 141H928.7C922.4 118.8 901.9 102.5 877.7 102.5Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.9 102.5C992.7 102.5 972.2 118.8 965.9 141H1067.9C1061.5 118.8 1041.1 102.5 1016.9 102.5Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.6 86.1C916 86.1 886.8 109.3 877.7 141H1023.4C1014.4 109.3 985.2 86.1 950.6 86.1Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.3 184.3C1008.6 184.3 995.4 194.8 991.3 209.2H1057.3C1053.3 194.9 1040 184.3 1024.3 184.3Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.4 184.3C1098.7 184.3 1085.5 194.8 1081.4 209.2H1147.4C1143.3 194.9 1130.1 184.3 1114.4 184.3Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.5 173.7C1049.1 173.7 1030.2 188.7 1024.3 209.3H1118.6C1112.8 188.7 1093.9 173.7 1071.5 173.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.1 268.1C386.6 268.1 379.5 273.8 377.2 281.6H412.9C410.7 273.8 403.5 268.1 395.1 268.1Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.8 268.1C435.3 268.1 428.2 273.8 425.9 281.6H461.6C459.4 273.8 452.3 268.1 443.8 268.1Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.6 262.3C408.5 262.3 398.3 270.4 395.1 281.5H446.1C442.9 270.4 432.7 262.3 420.6 262.3Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.8 408.1C888.1 408.1 882.5 412.6 880.7 418.7H908.9C907.1 412.6 901.5 408.1 894.8 408.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.2 408.1C926.5 408.1 920.9 412.6 919.1 418.7H947.3C945.5 412.6 939.9 408.1 933.2 408.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.9 403.6C905.3 403.6 897.3 410 894.8 418.8H935C932.5 410 924.5 403.6 914.9 403.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6 225.7C268.7 225.7 256.9 235 253.3 247.8H312C308.2 235.1 296.5 225.7 282.6 225.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.6 225.7C348.7 225.7 336.9 235 333.3 247.8H392C388.3 235.1 376.5 225.7 362.6 225.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.4 216.2C304.5 216.2 287.7 229.6 282.5 247.8H366.3C361.1 229.6 344.4 216.2 324.4 216.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7 206.2C437.1 205.6 440.6 202.1 441.2 197.7C441.2 197.6 441.4 197.6 441.4 197.7C442 202.1 445.5 205.6 449.9 206.2C450 206.2 450 206.4 449.9 206.4C445.5 207 442 210.5 441.4 214.9C441.4 215 441.2 215 441.2 214.9C440.6 210.5 437.1 207 432.7 206.4C432.5 206.3 432.5 206.2 432.7 206.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.6 387.9C617 387.3 620.5 383.8 621.1 379.4C621.1 379.3 621.3 379.3 621.3 379.4C621.9 383.8 625.4 387.3 629.8 387.9C629.9 387.9 629.9 388.1 629.8 388.1C625.4 388.7 621.9 392.2 621.3 396.6C621.3 396.7 621.1 396.7 621.1 396.6C620.5 392.2 617 388.7 612.6 388.1C612.5 388.1 612.5 387.9 612.6 387.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.9 387.9C872.3 387.3 875.8 383.8 876.4 379.4C876.4 379.3 876.6 379.3 876.6 379.4C877.2 383.8 880.7 387.3 885.1 387.9C885.2 387.9 885.2 388.1 885.1 388.1C880.7 388.7 877.2 392.2 876.6 396.6C876.6 396.7 876.4 396.7 876.4 396.6C875.8 392.2 872.3 388.7 867.9 388.1C867.8 388.1 867.8 387.9 867.9 387.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.5 172.3C482.8 171.9 484.5 170.1 485 167.8C485 167.7 485.2 167.7 485.2 167.8C485.6 170.1 487.4 171.8 489.7 172.3C489.8 172.3 489.8 172.5 489.7 172.5C487.4 172.9 485.7 174.7 485.2 177C485.2 177.1 485 177.1 485 177C484.6 174.7 482.8 173 480.5 172.5C480.4 172.4 480.4 172.3 480.5 172.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.6 352.2C933.9 351.8 935.6 350 936.1 347.7C936.1 347.6 936.3 347.6 936.3 347.7C936.7 350 938.5 351.7 940.8 352.2C940.9 352.2 940.9 352.4 940.8 352.4C938.5 352.8 936.8 354.6 936.3 356.9C936.3 357 936.1 357 936.1 356.9C935.7 354.6 933.9 352.9 931.6 352.4C931.5 352.4 931.5 352.2 931.6 352.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9 518.1C406.9 522.8 404.7 527.1 401.3 529.8H382.5C379.9 527.7 378 524.8 377.3 521.5C377 520.4 376.9 519.3 376.9 518.1C376.9 509.8 383.6 503.1 391.9 503.1C395.7 503.1 399.2 504.5 401.9 506.9C405 509.6 406.9 513.6 406.9 518.1Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3 510.5C402.3 518.7 395.6 525.4 387.4 525.4C383.5 525.4 380 523.9 377.3 521.5C377 520.4 376.9 519.3 376.9 518.1C376.9 509.8 383.6 503.1 391.9 503.1C395.7 503.1 399.2 504.5 401.9 506.9C402.2 508.1 402.3 509.3 402.3 510.5Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3 499.8C402.3 505.5 397.6 510.2 391.9 510.2C387.3 510.2 383.3 507.2 382 503C381.7 502 381.5 500.9 381.5 499.8C381.5 494.1 386.2 489.4 391.9 489.4C394.3 489.4 396.5 490.2 398.3 491.6C400.7 493.5 402.3 496.4 402.3 499.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.8 494.7C398.8 500.4 394.1 505.1 388.4 505.1C386 505.1 383.8 504.3 382 502.9C381.7 501.9 381.5 500.8 381.5 499.7C381.5 494 386.2 489.3 391.9 489.3C394.3 489.3 396.5 490.1 398.3 491.5C398.6 492.6 398.8 493.6 398.8 494.7Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.8 545.2C627.8 549.9 625.6 554.2 622.2 556.9H603.4C600.8 554.8 598.9 551.9 598.2 548.6C597.9 547.5 597.8 546.4 597.8 545.2C597.8 536.9 604.5 530.2 612.8 530.2C616.6 530.2 620.1 531.6 622.8 534C625.8 536.7 627.8 540.7 627.8 545.2Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.2 537.6C623.2 545.8 616.5 552.5 608.3 552.5C604.4 552.5 600.9 551 598.2 548.6C597.9 547.5 597.8 546.4 597.8 545.2C597.8 536.9 604.5 530.2 612.8 530.2C616.6 530.2 620.1 531.6 622.8 534C623 535.1 623.2 536.4 623.2 537.6Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.2 526.8C623.2 532.5 618.5 537.2 612.8 537.2C608.2 537.2 604.2 534.2 602.9 530C602.6 529 602.4 527.9 602.4 526.8C602.4 521.1 607.1 516.4 612.8 516.4C615.2 516.4 617.4 517.2 619.2 518.6C621.6 520.5 623.2 523.5 623.2 526.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.6 521.8C619.6 527.5 614.9 532.2 609.2 532.2C606.8 532.2 604.6 531.4 602.8 530C602.5 529 602.3 527.9 602.3 526.8C602.3 521.1 607 516.4 612.7 516.4C615.1 516.4 617.3 517.2 619.1 518.6C619.5 519.6 619.6 520.7 619.6 521.8Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.2 468.5C143.2 473.2 141 477.5 137.6 480.2H118.8C116.2 478.1 114.3 475.2 113.6 471.9C113.3 470.8 113.2 469.7 113.2 468.5C113.2 460.2 119.9 453.5 128.2 453.5C132 453.5 135.5 454.9 138.2 457.3C141.3 460.1 143.2 464.1 143.2 468.5Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6 460.9C138.6 469.1 131.9 475.8 123.7 475.8C119.8 475.8 116.3 474.3 113.6 471.9C113.3 470.8 113.2 469.7 113.2 468.5C113.2 460.2 119.9 453.5 128.2 453.5C132 453.5 135.5 454.9 138.2 457.3C138.5 458.5 138.6 459.7 138.6 460.9Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6 450.2C138.6 455.9 133.9 460.6 128.2 460.6C123.6 460.6 119.6 457.6 118.3 453.4C118 452.4 117.8 451.3 117.8 450.2C117.8 444.5 122.5 439.8 128.2 439.8C130.6 439.8 132.8 440.6 134.6 442C137 443.9 138.6 446.9 138.6 450.2Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1 445.2C135.1 450.9 130.4 455.6 124.7 455.6C122.3 455.6 120.1 454.8 118.3 453.4C118 452.4 117.8 451.3 117.8 450.2C117.8 444.5 122.5 439.8 128.2 439.8C130.6 439.8 132.8 440.6 134.6 442C134.9 443 135.1 444.1 135.1 445.2Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.4 628H685.9L678.8 535.5L676 498.9L710.9 404.5L763.8 411.5L938.4 508.7L946 524.8L980.5 597.1L1019.4 628Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.7 542.4V467.6",
    stroke: "#369094",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.7 486.6L880.6 478.6",
    stroke: "#369094",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.7 510L880.6 502",
    stroke: "#369094",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.7 495L864.4 486.8",
    stroke: "#369094",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.7 455.4V479.9C872.7 479.9 877.8 474.4 877.8 467.7C877.8 460.9 872.7 455.4 872.7 455.4Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.6 467.6C867.6 474.4 872.7 479.8 872.7 479.8V455.3C872.7 455.4 867.6 460.9 867.6 467.6Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.8 466.5L877.8 481.5C877.8 481.5 884.3 481.3 888.4 477.1C892.6 473 892.8 466.5 892.8 466.5Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.2 470.9C878 475.1 877.8 481.5 877.8 481.5L892.8 466.5C892.8 466.5 886.3 466.7 882.2 470.9Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.9 482.7L877.8 504.8C877.8 504.8 887.4 504.5 893.5 498.4C899.6 492.3 899.9 482.7 899.9 482.7Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.2 489.2C878.1 495.3 877.8 504.9 877.8 504.9L899.9 482.8C899.9 482.7 890.4 483.1 884.2 489.2Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.2 488.5L852.1 474.4C852.1 474.4 852.3 480.5 856.2 484.4C860.1 488.3 866.2 488.5 866.2 488.5Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.1 478.5C858.2 474.6 852.1 474.4 852.1 474.4L866.2 488.5C866.2 488.5 866 482.4 862.1 478.5Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.7 517.4L864.4 509.2",
    stroke: "#369094",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.2 510.9L846.6 491.3C846.6 491.3 846.9 499.8 852.3 505.2C857.7 510.6 866.2 510.9 866.2 510.9Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.5 497.1C855.1 491.7 846.6 491.4 846.6 491.4L866.2 511C866.2 510.9 865.9 502.5 860.5 497.1Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.3 628H718C713.5 600.2 707.5 564 703.2 537.8C699.9 517.6 697.5 503.3 697.5 503.3L723.8 427.5L833.5 521.3L867 527.7L885.2 531.2L940.3 628Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.4 423.6C729.6 423.6 729.8 423.6 729.9 423.6C731.4 423.5 732.5 422.1 732.3 420.6L730.4 401.1C730.3 399.6 728.9 398.5 727.4 398.7C725.9 398.8 724.8 400.2 725 401.7L726.9 421.2C727.1 422.5 728.1 423.5 729.4 423.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.1 420.5C733.1 420.5 733.1 427.7 731.4 427.5C729.7 427.3 705.9 422.2 706.1 421.1C706.5 417.2 726.7 418.5 728.5 419.4C730.3 420.3 733.1 419.4 733.1 420.5Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.4 273C748.8 291.3 737.6 310.6 726.3 329.7C714.5 349.5 724 383.2 724.2 410.9C727.1 411.1 732.2 414 733.1 411.3C734.4 407.6 727.2 350.7 736.2 337.7C746.7 322.6 760.7 309.4 770.4 293.6C767.7 286.8 764.4 279.9 761.4 273Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.4 446.1C814.6 446.1 814.8 446.1 814.9 446C816.4 445.7 817.3 444.2 817 442.7L812.7 423.6C812.4 422.1 810.9 421.2 809.4 421.5C807.9 421.8 807 423.3 807.3 424.8L811.6 443.9C812 445.3 813.1 446.1 814.4 446.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.1 443.2C818.1 443.2 817.5 450.4 815.9 450.1C814.2 449.8 790.9 443 791.1 441.9C791.8 438.1 811.8 440.8 813.6 441.8C815.2 442.7 818.2 442.2 818.1 443.2Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.2 434.5C811.1 433.8 814.1 433.1 816.9 432.1C797.1 387.2 781.5 321.1 783.1 271.9C775.2 271.9 767.4 271.9 759.5 272C765.5 324.7 789.9 384.6 808.2 434.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.8 288.9C754.4 287.4 763.9 289.8 768.5 288.9C775.2 287.5 778.6 288 785.2 288.4C786.1 267.5 785.3 245.6 786.9 225.1C787.2 220.8 787.4 218.2 786.6 215C785.5 210.6 783.3 207.6 780.3 206.1C776.7 204.1 772.1 204.3 767.4 206.7C766.7 207 766.1 207.4 765.4 207.9C762.6 210 760.1 214.1 759.7 221.9C758.7 241.3 753.5 268.8 749.8 288.9Z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.9 280.7C790.9 280.7 776.9 285.5 775.7 289C774.5 292.5 788.3 289.4 794 282.6L790.9 280.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.8 279.4C791.1 281.5 792.5 283.6 793.7 285.6C829 257.8 826.8 241.1 788.5 211.7C782.6 207.2 782.4 208.3 779.6 212.7C778.5 212.3 778.6 212.3 779.6 212.7C776.8 217.1 779 218.4 783.6 221.9C813.8 245 820.3 257.5 789.8 279.4Z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.3 193.4C774.8 200.3 766.3 202.8 762.1 200C757.9 197.3 759.5 190.3 764 183.4C768.5 176.5 774.2 175.2 778.4 177.9C782.7 180.8 783.8 186.5 779.3 193.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.9 197.8C779.9 199.4 776.9 200.4 775.7 199.7C774.5 198.9 775.1 197.4 776.1 195.8C777.1 194.2 779.1 193.3 780.2 194.1C781.5 194.9 781.9 196.2 780.9 197.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.3 192.3L769.7 191.5C769.6 192.7 768.7 203.9 769.1 208.2C769.4 209.5 771.6 210.1 773.9 209.5C776 209 777.5 207.7 777.6 206.5C777.3 203.9 777.9 196.4 778.3 192.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.1 195.8C773.8 194.4 772.6 195.7 769.6 197.4C766.5 199.1 761.1 198.7 760.7 191.5C760.5 186.9 757.9 194.4 757.9 194.4C757.4 198.1 758.4 200.4 760.9 202C764.4 204.3 769.9 203.9 774.8 201C775.5 199.2 776 196.7 775.1 195.8Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.4 191.2C760.4 191.2 760.5 191.3 760.7 191.4C762.2 192.2 769 196.1 769.7 198.9C770.5 202.1 766 197.7 764.7 195.6C763.4 193.6 761.7 193.8 760.3 193.4C758.8 193 758.2 191.1 760.4 191.2Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.2 189.7C783.2 189.7 784.6 184.3 782.2 180.5C779.8 176.6 772.9 172.6 767.5 177.8C767.5 177.8 764 181.8 769.2 185.7C774.4 189.5 775.1 186 776.3 190.3C777.5 194.6 781.1 193.9 781.3 194.8L783.2 189.7Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.2 178.9C754.2 178.9 766.8 186.5 770.3 185.2C773.8 183.9 762.6 175.3 753.7 175.3L754.2 178.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.7 182.2C758.8 180.1 758.8 176.1 758.9 175.3C698.6 163.2 714.1 208.7 757.9 218.7C764.6 220.2 765 219.5 765.8 214.1C766.9 214 766.9 214.1 765.8 214.1C766.6 208.7 762.8 208.6 758.3 207.6C728.9 201.5 710.4 173.7 757.7 182.2Z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.4 207.9L765.8 221L766.3 237.4L773.1 222.1L780.3 206.1C776.7 204.1 772.1 204.3 767.4 206.7C766.8 207 766.1 207.4 765.4 207.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.8 221L766.3 237.4L773.1 222.1L772.9 212.2H769.9L765.8 221Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.762 222.35C669.372 198.594 654.661 174.787 630.904 169.178C607.147 163.568 583.341 178.279 577.731 202.036C572.122 225.793 586.833 249.599 610.59 255.209C634.346 260.818 658.152 246.107 663.762 222.35Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.6 220.2C654.9 220.2 649.3 224.7 647.5 230.8H675.7C673.9 224.6 668.3 220.2 661.6 220.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 220.2C693.3 220.2 687.7 224.7 685.9 230.8H714.1C712.3 224.6 706.7 220.2 700 220.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.7 215.6C672.1 215.6 664.1 222 661.6 230.8H701.8C699.3 222 691.3 215.6 681.7 215.6Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1 485.2C374.1 499.2 362.2 510.5 348 509.5C339.7 508.9 332.5 504.1 328.6 497.3C326.7 493.9 325.5 490.1 325.4 486C325.2 479.9 327.2 474.4 330.7 470C332.8 467.3 333.4 463.8 332.3 460.6C331.7 458.7 331.3 456.7 331.3 454.6C331.3 444 340.2 435.5 351 436.2C353.9 436.4 356.7 437.3 359.1 438.7C364.3 441.7 367.9 447.2 368.3 453.5C368.4 456 368.1 458.3 367.4 460.5C366.3 463.8 366.8 467.3 369 470C372.1 474.2 374.1 479.5 374.1 485.2Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8 452.3C360.8 474.8 346.9 493.5 328.6 497.3C326.7 493.9 325.5 490.1 325.4 486C325.2 479.9 327.2 474.4 330.7 470C332.8 467.3 333.4 463.8 332.3 460.6C331.7 458.7 331.3 456.7 331.3 454.6C331.3 444 340.2 435.5 351 436.2C353.9 436.4 356.7 437.3 359.1 438.7C360.1 443 360.8 447.6 360.8 452.3Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7 461.5V523",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7 496.7L359.1 487.3",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7 477.5L342.9 470.7",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.7 472.3C465.7 486.3 453.8 497.6 439.6 496.6C431.3 496 424.1 491.2 420.2 484.4C418.3 481 417.1 477.2 417 473.1C416.8 467 418.8 461.5 422.3 457.1C424.4 454.4 425 450.9 423.9 447.7C423.3 445.8 422.9 443.8 422.9 441.7C422.9 431.1 431.8 422.6 442.6 423.3C445.5 423.5 448.3 424.4 450.7 425.8C455.9 428.8 459.5 434.3 459.9 440.6C460 443.1 459.7 445.4 459 447.6C457.9 450.9 458.4 454.4 460.6 457.1C463.7 461.3 465.7 466.6 465.7 472.3Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.3 439.5C452.3 462 438.4 480.7 420.1 484.5C418.2 481.1 417 477.3 416.9 473.2C416.7 467.1 418.7 461.6 422.2 457.2C424.3 454.5 424.9 451 423.8 447.8C423.2 445.9 422.8 443.9 422.8 441.8C422.8 431.2 431.7 422.7 442.5 423.4C445.4 423.6 448.2 424.5 450.6 425.9C451.7 430.1 452.3 434.7 452.3 439.5Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.3 448.7V510.2",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.3 483.9L450.7 474.5",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.3 464.7L434.5 457.8",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.8 519.9C494.8 533.9 482.9 545.2 468.7 544.2C460.4 543.6 453.2 538.8 449.3 532C447.4 528.6 446.2 524.8 446.1 520.7C445.9 514.6 447.9 509.1 451.4 504.7C453.5 502 454.1 498.5 453 495.3C452.4 493.4 452 491.4 452 489.3C452 478.7 460.9 470.2 471.7 470.9C474.6 471.1 477.4 472 479.8 473.4C485 476.4 488.6 481.9 489 488.2C489.1 490.7 488.8 493 488.1 495.2C487 498.5 487.5 502 489.7 504.7C492.8 508.9 494.8 514.2 494.8 519.9Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.5 487C481.5 509.5 467.6 528.2 449.3 532C447.4 528.6 446.2 524.8 446.1 520.7C445.9 514.6 447.9 509.1 451.4 504.7C453.5 502 454.1 498.5 453 495.3C452.4 493.4 452 491.4 452 489.3C452 478.7 460.9 470.2 471.7 470.9C474.6 471.1 477.4 472 479.8 473.4C480.9 477.7 481.5 482.3 481.5 487Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.4 496.2V557.7",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.4 531.4L479.8 522",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.4 512.2L463.6 505.4",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.9 539.2C582.9 553.2 571 564.5 556.8 563.5C548.5 562.9 541.3 558.1 537.4 551.3C535.5 547.9 534.3 544.1 534.2 540C534 533.9 536 528.4 539.5 524C541.6 521.3 542.2 517.8 541.1 514.6C540.5 512.7 540.1 510.7 540.1 508.6C540.1 498 549 489.5 559.8 490.2C562.7 490.4 565.5 491.3 567.9 492.7C573.1 495.7 576.7 501.2 577.1 507.5C577.2 510 576.9 512.3 576.2 514.5C575.1 517.8 575.6 521.3 577.8 524C580.9 528.2 582.9 533.5 582.9 539.2Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.6 506.4C569.6 528.9 555.7 547.6 537.4 551.4C535.5 548 534.3 544.2 534.2 540.1C534 534 536 528.5 539.5 524.1C541.6 521.4 542.2 517.9 541.1 514.7C540.5 512.8 540.1 510.8 540.1 508.7C540.1 498.1 549 489.6 559.8 490.3C562.7 490.5 565.5 491.4 567.9 492.8C568.9 497 569.6 501.6 569.6 506.4Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 515.6V577.1",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 550.8L567.9 541.4",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 531.6L551.7 524.7",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.7 547C526.7 561 514.8 572.3 500.6 571.3C492.3 570.7 485.1 565.9 481.2 559.1C479.3 555.7 478.1 551.9 478 547.8C477.8 541.7 479.8 536.2 483.3 531.8C485.4 529.1 486 525.6 484.9 522.4C484.3 520.5 483.9 518.5 483.9 516.4C483.9 505.8 492.8 497.3 503.6 498C506.5 498.2 509.3 499.1 511.7 500.5C516.9 503.5 520.5 509 520.9 515.3C521 517.8 520.7 520.1 520 522.3C518.9 525.6 519.4 529.1 521.6 531.8C524.7 536 526.7 541.2 526.7 547Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.4 514.1C513.4 536.6 499.5 555.3 481.2 559.1C479.3 555.7 478.1 551.9 478 547.8C477.8 541.7 479.8 536.2 483.3 531.8C485.4 529.1 486 525.6 484.9 522.4C484.3 520.5 483.9 518.5 483.9 516.4C483.9 505.8 492.8 497.3 503.6 498C506.5 498.2 509.3 499.1 511.7 500.5C512.7 504.7 513.4 509.3 513.4 514.1Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3 523.3V584.8",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3 558.5L511.7 549.1",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3 539.3L495.5 532.5",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 439.4C275 453.4 263.1 464.7 248.9 463.7C240.6 463.1 233.4 458.3 229.5 451.5C227.6 448.1 226.4 444.3 226.3 440.2C226.1 434.1 228.1 428.6 231.6 424.2C233.7 421.5 234.3 418 233.2 414.8C232.6 412.9 232.2 410.9 232.2 408.8C232.2 398.2 241.1 389.7 251.9 390.4C254.8 390.6 257.6 391.5 260 392.9C265.2 395.9 268.8 401.4 269.2 407.7C269.3 410.2 269 412.5 268.3 414.7C267.2 418 267.7 421.5 269.9 424.2C273 428.4 275 433.7 275 439.4Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6 406.6C261.6 429.1 247.7 447.8 229.4 451.6C227.5 448.2 226.3 444.4 226.2 440.3C226 434.2 228 428.7 231.5 424.3C233.6 421.6 234.2 418.1 233.1 414.9C232.5 413 232.1 411 232.1 408.9C232.1 398.3 241 389.8 251.8 390.5C254.7 390.7 257.5 391.6 259.9 393C261 397.2 261.6 401.8 261.6 406.6Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6 415.8V477.3",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6 450.9L260 441.6",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6 431.8L243.7 424.9",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.3 542.9C1029.3 556.9 1017.4 568.2 1003.2 567.2C994.9 566.6 987.7 561.8 983.8 555C981.9 551.6 980.7 547.8 980.6 543.7C980.4 537.6 982.4 532.1 985.9 527.7C988 525 988.6 521.5 987.5 518.3C986.9 516.4 986.5 514.4 986.5 512.3C986.5 501.7 995.4 493.2 1006.2 493.9C1009.1 494.1 1011.9 495 1014.3 496.4C1019.5 499.4 1023.1 504.9 1023.5 511.2C1023.6 513.7 1023.3 516 1022.6 518.2C1021.5 521.5 1022 525 1024.2 527.7C1027.3 531.9 1029.3 537.1 1029.3 542.9Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016 510C1016 532.5 1002.1 551.2 983.8 555C981.9 551.6 980.7 547.8 980.6 543.7C980.4 537.6 982.4 532.1 985.9 527.7C988 525 988.6 521.5 987.5 518.3C986.9 516.4 986.5 514.4 986.5 512.3C986.5 501.7 995.4 493.2 1006.2 493.9C1009.1 494.1 1011.9 495 1014.3 496.4C1015.3 500.6 1016 505.2 1016 510Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.9 519.2V580.7",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.9 554.4L1014.3 545",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.9 535.2L998.1 528.4",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.1 572.6C1089.1 586.6 1077.2 597.9 1063 596.9C1054.7 596.3 1047.5 591.5 1043.6 584.7C1041.7 581.3 1040.5 577.5 1040.4 573.4C1040.2 567.3 1042.2 561.8 1045.7 557.4C1047.8 554.7 1048.4 551.2 1047.3 548C1046.7 546.1 1046.3 544.1 1046.3 542C1046.3 531.4 1055.2 522.9 1066 523.6C1068.9 523.8 1071.7 524.7 1074.1 526.1C1079.3 529.1 1082.9 534.6 1083.3 540.9C1083.4 543.4 1083.1 545.7 1082.4 547.9C1081.3 551.2 1081.8 554.7 1084 557.4C1087.1 561.6 1089.1 566.9 1089.1 572.6Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.7 539.8C1075.7 562.3 1061.8 581 1043.5 584.8C1041.6 581.4 1040.4 577.6 1040.3 573.5C1040.1 567.4 1042.1 561.9 1045.6 557.5C1047.7 554.8 1048.3 551.3 1047.2 548.1C1046.6 546.2 1046.2 544.2 1046.2 542.1C1046.2 531.5 1055.1 523 1065.9 523.7C1068.8 523.9 1071.6 524.8 1074 526.2C1075.1 530.4 1075.7 535 1075.7 539.8Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.7 548.9V610.4",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.7 584.1L1074.1 574.7",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.7 564.9L1057.8 558.1",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2 476.4C201.2 490.4 189.3 501.7 175.1 500.7C166.8 500.1 159.6 495.3 155.7 488.5C153.8 485.1 152.6 481.3 152.5 477.2C152.3 471.1 154.3 465.6 157.8 461.2C159.9 458.5 160.5 455 159.4 451.8C158.8 449.9 158.4 447.9 158.4 445.8C158.4 435.2 167.3 426.7 178.1 427.4C181 427.6 183.8 428.5 186.2 429.9C191.4 432.9 195 438.4 195.4 444.7C195.5 447.2 195.2 449.5 194.5 451.7C193.4 455 193.9 458.5 196.1 461.2C199.2 465.4 201.2 470.7 201.2 476.4Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8 443.6C187.8 466.1 173.9 484.8 155.6 488.6C153.7 485.2 152.5 481.4 152.4 477.3C152.2 471.2 154.2 465.7 157.7 461.3C159.8 458.6 160.4 455.1 159.3 451.9C158.7 450 158.3 448 158.3 445.9C158.3 435.3 167.2 426.8 178 427.5C180.9 427.7 183.7 428.6 186.1 430C187.2 434.2 187.8 438.8 187.8 443.6Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8 452.8V514.3",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8 488L186.2 478.6",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8 468.8L170 461.9",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6 529.1C419.6 532 418.3 534.6 416.2 536.3H404.7C403.1 535 402 533.3 401.5 531.2C401.3 530.5 401.3 529.8 401.3 529.1C401.3 524 405.4 519.9 410.5 519.9C412.8 519.9 415 520.8 416.6 522.2C418.4 524 419.6 526.4 419.6 529.1Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.8 524.5C416.8 529.5 412.7 533.6 407.7 533.6C405.3 533.6 403.1 532.7 401.5 531.2C401.3 530.5 401.3 529.8 401.3 529.1C401.3 524 405.4 519.9 410.5 519.9C412.8 519.9 415 520.8 416.6 522.2C416.7 523 416.8 523.7 416.8 524.5Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.9 558.7C636.9 561.6 635.6 564.2 633.5 565.9H622C620.4 564.6 619.3 562.9 618.8 560.8C618.6 560.1 618.6 559.4 618.6 558.7C618.6 553.6 622.7 549.5 627.8 549.5C630.1 549.5 632.3 550.4 633.9 551.8C635.7 553.5 636.9 556 636.9 558.7Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.1 554.1C634.1 559.1 630 563.2 625 563.2C622.6 563.2 620.4 562.3 618.8 560.8C618.6 560.1 618.6 559.4 618.6 558.7C618.6 553.6 622.7 549.5 627.8 549.5C630.1 549.5 632.3 550.4 633.9 551.8C634 552.6 634.1 553.3 634.1 554.1Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.5 585.8C1033.5 588.7 1032.2 591.3 1030.1 593H1018.6C1017 591.7 1015.9 590 1015.4 587.9C1015.2 587.2 1015.2 586.5 1015.2 585.8C1015.2 580.7 1019.3 576.6 1024.4 576.6C1026.7 576.6 1028.9 577.5 1030.5 578.9C1032.3 580.6 1033.5 583.1 1033.5 585.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.7 581.2C1030.7 586.2 1026.6 590.3 1021.6 590.3C1019.2 590.3 1017 589.4 1015.4 587.9C1015.2 587.2 1015.2 586.5 1015.2 585.8C1015.2 580.7 1019.3 576.6 1024.4 576.6C1026.7 576.6 1028.9 577.5 1030.5 578.9C1030.6 579.6 1030.7 580.4 1030.7 581.2Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9 466.4C311.9 469.3 310.6 471.9 308.5 473.6H297C295.4 472.3 294.3 470.6 293.8 468.5C293.6 467.8 293.6 467.1 293.6 466.4C293.6 461.3 297.7 457.2 302.8 457.2C305.1 457.2 307.3 458.1 308.9 459.5C310.7 461.2 311.9 463.6 311.9 466.4Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1 461.7C309.1 466.7 305 470.8 300 470.8C297.6 470.8 295.4 469.9 293.8 468.4C293.6 467.7 293.6 467 293.6 466.3C293.6 461.2 297.7 457.1 302.8 457.1C305.1 457.1 307.3 458 308.9 459.4C309 460.2 309.1 461 309.1 461.7Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2 495C232.2 509 220.3 520.3 206.1 519.3C197.8 518.7 190.6 513.9 186.7 507.1C184.8 503.7 183.6 499.9 183.5 495.8C183.3 489.7 185.3 484.2 188.8 479.8C190.9 477.1 191.5 473.6 190.4 470.4C189.8 468.5 189.4 466.5 189.4 464.4C189.4 453.8 198.3 445.3 209.1 446C212 446.2 214.8 447.1 217.2 448.5C222.4 451.5 226 457 226.4 463.3C226.5 465.8 226.2 468.1 225.5 470.3C224.4 473.6 224.9 477.1 227.1 479.8C230.3 484 232.2 489.2 232.2 495Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.9 462.1C218.9 484.6 205 503.3 186.7 507.1C184.8 503.7 183.6 499.9 183.5 495.8C183.3 489.7 185.3 484.2 188.8 479.8C190.9 477.1 191.5 473.6 190.4 470.4C189.8 468.5 189.4 466.5 189.4 464.4C189.4 453.8 198.3 445.3 209.1 446C212 446.2 214.8 447.1 217.2 448.5C218.3 452.8 218.9 457.4 218.9 462.1Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 471.3V532.8",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 506.5L217.3 497.1",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 487.3L201 480.5",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide2.a528b4ea4e2328427117c76370ba1540.svg";
export { ForwardRef as ReactComponent };